interface ModalEventHandlersModel {
   onClose?(): void;
   onDismiss?(): void;
   onConfirm?(): void;
   onCustomEvent?(eventName: string, eventParams?: any): any;
}

export const nullModalEventHandlersFactory = (): ModalEventHandlersModel => ({
   onClose: null,
   onDismiss: null,
   onConfirm: null,
   onCustomEvent: null
});

export default ModalEventHandlersModel;
